<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-card>
                <v-layout row wrap pa-6 pb-0>
                    <v-flex lg6 md6 sm12>
                        <v-autocomplete label="Khách hàng" v-model="selectedCustomerId" :items="customers" :item-text="getCustomerText" item-value="id" class="input-group--focused" :disabled="currentItem.id > 0"></v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout row wrap pa-6 pb-0>
                    <v-flex lg6 md6 sm12>
                        <v-text-field label="Ghi chú" v-model="currentItem.note"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap pa-6 pt-0>
                    <v-layout row wrap justify-end pl-4>
                        <v-flex lg6 md6 sm8>
                            <v-autocomplete label="Sản phẩm" v-model="selectedProductId" :items="products" :item-text="getProductText" item-value="id" class="input-group--focused">
                                <template v-slot:selection="data">
                                    <v-chip v-bind="data.attrs" :input-value="data.selected" @click="data.select">
                                        {{ data.item.product_code + ' - ' + data.item.name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="data.item.product_code + ' - ' + data.item.name"></v-list-item-title>
                                            <v-list-item-subtitle v-html="format_number(selectedCustomer && selectedCustomer.retailer && data.item.retail_price ? data.item.retail_price : data.item.price)"></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                        <v-flex lg6 md6 sm4>
                            <h-currency-input label="Số lượng" v-model="productQty" class="input-group--focused" :decimal="0"></h-currency-input>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-end pl-4>
                        <v-flex lg12>
                            <v-btn
                                class="mx-2"
                                dark
                                small
                                color="red"
                                @click="addDetail"
                                ><v-icon dark>add</v-icon></v-btn
                            >
                            <v-btn
                                class="mx-2"
                                small
                                @click="refreshDetail"
                                ><v-icon dark>refresh</v-icon></v-btn
                            >
                        </v-flex>
                    </v-layout>
                    <v-flex lg12>
                        <v-layout row wrap justify-end>
                            <v-flex lg12 md12 sm12>
                                <h5>Sản phẩm khách không đặt</h5>
                            </v-flex>
                            <v-flex lg2 md2 sm12>
                                <v-autocomplete
                                    v-model="otherProductId"
                                    :items="search_items"
                                    :search-input.sync="search_term"
                                    :loading="loading_product"
                                    hide-no-data
                                    placeholder="Tìm tên hoặc mã sản phẩm"
                                    :item-text="filter_proname"
                                    item-value="id"
                                    @change="onSelectSuggestion"
                                    >
                                </v-autocomplete>
                            </v-flex>
                            <v-flex lg4 md4 sm12>
                                <v-text-field label="Tên sản phẩm" v-model="otherProductName"></v-text-field>
                            </v-flex>
                            <v-flex lg2 md2 sm12>
                                <h-currency-input label="Số lượng" v-model="otherProductQty" class="input-group--focused" :decimal="0"></h-currency-input>
                            </v-flex>
                            <v-flex lg2 md2 sm12>
                                <h-currency-input label="Đơn giá" v-model="otherProductPrice" class="input-group--focused" :decimal="0"></h-currency-input>
                            </v-flex>
                            <v-flex lg2 md2 sm12 mt-4>
                                <v-btn
                                    class="mx-2"
                                    dark
                                    small
                                    color="blue"
                                    @click="addOtherDetail"
                                    ><v-icon dark>add</v-icon></v-btn
                                >
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex lg12>
                        <v-data-table :headers="detail_header" :items="currentItem.receipt_products" disable-pagination hide-default-footer :mobile-breakpoint="100">
                            <template v-slot:item="{ item }">
                                <tr>
                                <td>{{ item.product_code }}</td>
                                <td>{{ item.product_name }}</td>
                                <td class="text-right">{{ item.total_buy_qty | currency }}</td>
                                <td class="text-right">
                                    <v-edit-dialog :return-value.sync="item.qty" eager lazy @save="updateLineItem(item)">
                                        <div>{{ item.qty | currency }}</div>
                                        <template v-slot:input>
                                            <v-text-field v-model="item.qty" type="number" step="1" label="Số lượng" single-line autofocus></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-right">
                                    <v-edit-dialog :return-value.sync="item.unit_price" eager lazy @save="updateLineItem(item)">
                                        <div>{{ item.unit_price | currency }}</div>
                                        <template v-slot:input>
                                            <v-text-field v-model="item.unit_price" type="number" step="1" label="Đơn giá" single-line autofocus></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-right">
                                    <v-edit-dialog :return-value.sync="item.discount" eager lazy @save="updateLineItem(item)">
                                        <div>{{ item.discount | currency }}</div>
                                        <template v-slot:input>
                                            <v-text-field v-model="item.discount" type="number" step="1" label="Giảm giá" single-line autofocus></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-right">
                                    {{ item.price | currency }}
                                </td>
                                <td class="text-right">
                                    {{ item.line_total | currency }}
                                </td>
                                <td class="text-center">
                                    <v-icon medium @click="deleteDetail(item.product_id)">delete</v-icon>
                                </td>
                                </tr>
                            </template>
                            <template v-slot:body.append>
                                <tr class="total-summary-td">
                                    <td colspan="7" class="text-end font-weight-bold">Tổng số lượng:</td>
                                    <td class="text-end font-weight-bold">{{ currentItem.number_of_product | currency}}</td>
                                    <td></td>
                                </tr>
                                <tr class="total-summary-td">
                                    <td colspan="7" class="text-end font-weight-bold">Tổng tiền hàng:</td>
                                    <td class="text-end font-weight-bold">{{ currentItem.total | currency}}</td>
                                    <td></td>
                                </tr>
                                <tr class="total-summary-td">
                                    <td colspan="7" class="text-end font-weight-bold">Tổng giảm giá:</td>
                                    <td class="text-end font-weight-bold">
                                        <h-currency-input class="fee-cn-footer" v-model="currentItem.discount" :decimal="0"></h-currency-input>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr class="total-summary-td">
                                    <td colspan="7" class="text-end font-weight-bold">Khách cần trả:</td>
                                    <td class="text-end font-weight-bold">{{ currentItem.amount | currency}}</td>
                                    <td></td>
                                </tr>
                                <tr class="total-summary-td">
                                    <td colspan="7" class="text-end font-weight-bold">Khách đã trả:</td>
                                    <td class="text-end font-weight-bold">
                                        <h-currency-input class="fee-cn-footer" v-model="currentItem.paid" :decimal="0"></h-currency-input>
                                    </td>
                                    <td></td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-container>
    </div>
    </template>
    
    <script>
    import { mapState } from "vuex";
    import configs from "@/configs";
    import { currency } from '@/commons/currency'
    import { sendSuccessNotice, sendErrorNotice, pad } from "@/commons/utils";
    import { print_export_receipt } from "@/commons/hpod";
    import moment from "moment"
    export default {
        data() {
            return {
                detail_header: [
                    {
                        text: "Mã sản phẩm",
                        value: "product_code",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"],
                    },
                    {
                        text: "Tên sản phẩm",
                        value: "product_name",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"],
                    },
                    {
                        text: "Tổng đặt",
                        value: "total_buy_qty",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                    },
                    {
                        text: "Số lượng",
                        value: "qty",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                    },
                    {
                        text: "Đơn giá",
                        value: "unit_price",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                    },
                    {
                        text: "Giảm giá",
                        value: "discount",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                    },
                    {
                        text: "Giá bán",
                        value: "price",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                    },
                    {
                        text: "Thành tiền",
                        value: "line_total",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                    },
                    {
                        text: "",
                        value: "",
                        align: "center",
                        width: "80px",
                    },
                ],
                dialogItem: false,
                selectedProductId: 0,
                selectedCustomerId: 0,
                selectedCustomer: null,
                productQty: 0,
                isChanged: false,
                format_number: currency,
                otherProductId: 0,
                otherProductCode: '',
                otherProductName: '',
                otherProductQty: 0,
                otherProductPrice: 0,
                search_items: [],
                search_term: '',
                loading_product: false
            }
        },
        computed: {
            ...mapState({
                loading: state => state.receipts.loading,
                customers: state => state.users.all.data,
                products: state => state.products.exp.data,
                currentItem: state => state.receipts.selected
            }),
            modifyId() {
                return this.$route.params.Pid;
            },
            isMobile() {
                if (screen.width <= 760) {
                    return true
                } else {
                    return false
                }
            },    
            adminRole() {
                return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Admin;
            },
        },
        watch: {
            modifyId() {
                this.refreshData();
            },
            currentItem() {
                if (this.currentItem) {
                    this.selectedCustomerId = this.currentItem.customer_id;
                }
            },
            selectedCustomerId() {
                if(this.selectedCustomerId > 0) {
                    this.$store.dispatch("products/getExpList", {'customer_id': this.selectedCustomerId});
                }
                this.currentItem.customer_id = this.selectedCustomerId;
                this.selectedCustomer = _.find(this.customers, {id: this.selectedCustomerId})
            },
            isChanged() {
                if(this.isChanged) {
                    this.saveData();
                }
            },
            search_term (val) {
                if (this.loading_product || !this.search_term) {
                    this.$store.commit("products/setList", {data: []})
                    return;
                }
                this.$store.commit("products/setList", {data: []})
                this.$store.dispatch("products/getList", {filter: [{
                    column: "product_code",
                    value: this.search_term,
                    condition: "contain",
                }], pagination: {...configs.PAGINATION, itemsPerPage: 20}}).then((p) => {
                    this.loading_product = false;
                    this.search_items.splice(0);
                    if(p.data) {
                        for (let i = 0; i < p.data.length; i++) {
                        const element = p.data[i];
                        this.search_items.push(element);
                        }
                    }
                });
            },
        },
        methods: {
            refreshData() {
                if (this.modifyId > 0) {
                    this.$store.dispatch("receipts/getDetail", this.modifyId);
                }
                else {
                    this.$store.commit("receipts/setDetail", { data: {
                            id: 0,
                            receipt_products: []
                        }
                    })
                }
            },
            getCustomerText(item) {
                return `${item.phone} - ${item.first_name}`
            },
            getProductText(item) {
                return `${item.product_code} - ${item.name} - (${this.format_number(item.price)})`
            },
            saveData() {
                this.$store.dispatch("receipts/setDetail", {
                    data: this.currentItem,
                    id: this.currentItem.id
                }).then((p) => {
                    this.isChanged = false;
                    if (p.status == 200 && p.data && p.data.id) {
                        this.$router.push({
                            name: "ExportOrderDetail",
                            params: {
                                Pid: p.data.id,
                                title: `Chi tiết đơn xuất (#${p.data.id})`
                            }
                         });
                    }
                });
            },
            refreshDetail() {
                if(this.selectedCustomerId > 0) {
                    this.$store.dispatch("products/getExpList", {'customer_id': this.selectedCustomerId});
                }
            },
            addDetail() {
                if(this.selectedProductId > 0) {
                    if(!this.productQty) {
                        sendErrorNotice('Hãy nhập số lượng sản phẩm.');
                        return;
                    }
                    if(this.currentItem.receipt_products === undefined || !this.currentItem.receipt_products) {
                        this.currentItem.receipt_products = []
                    }
                    let existedDetail = _.find(this.currentItem.receipt_products, {'product_id': this.selectedProductId});
                    if(existedDetail) {
                        existedDetail.qty = existedDetail.qty + this.productQty;
                        existedDetail.line_total = existedDetail.price*existedDetail.qty;
                        return;
                    }
                    
                    // if(_.find(this.products, (p) => { return p.id == this.selectedProductId && (!p.qty || p.qty < this.productQty) })) {
                    //     sendErrorNotice('Tồn kho sản phẩm không đủ để xuất hàng.');
                    //     return;
                    // }
                    let product = _.find(this.products, {'id': this.selectedProductId});
                    let product_price = this.selectedCustomer && this.selectedCustomer.retailer && product.retail_price ? product.retail_price : product.price;
                    this.currentItem.receipt_products.unshift({
                        product_id: product.id,
                        product_code: product.product_code,
                        product_name: product.name,
                        unit_price: product_price,
                        total_buy_qty: product.total_qty,
                        discount: 0,
                        price: product_price,
                        qty: this.productQty,
                        line_total: product_price*this.productQty
                    });
                    this.isChanged = true;
                }
                this.selectedProductId = 0;
                this.productQty = 0;
            },
            addOtherDetail() {
                if(!this.otherProductName) {
                    sendErrorNotice('Hãy nhập tên sản phẩm.');
                    return;
                }
                if(!this.otherProductQty) {
                    sendErrorNotice('Hãy nhập số lượng sản phẩm.');
                    return;
                }
                if(!this.otherProductPrice) {
                    sendErrorNotice('Hãy nhập đơn giá sản phẩm.');
                    return;
                }
                this.currentItem.receipt_products.unshift({
                    product_id: this.otherProductId,
                    product_code: this.otherProductCode,
                    product_name: this.otherProductName,
                    unit_price: this.otherProductPrice,
                    total_buy_qty: 0,
                    discount: 0,
                    price: this.otherProductPrice,
                    qty: this.otherProductQty,
                    line_total: this.otherProductPrice*this.otherProductQty
                });
                this.isChanged = true;
            },
            updateLineItem(item) {
                item.price = item.unit_price - item.discount;
                item.line_total = item.price * item.qty;
                this.isChanged = true;
            },
            deleteDetail(id) {
                this.currentItem.receipt_products = _.filter(this.currentItem.receipt_products, (p) => {return p.product_id != id;});
                this.isChanged = true;
            },
            printData() {
                if(this.isChanged) {
                    sendErrorNotice('Lưu lại hoá đơn trước khi in ấn.');
                    return;
                }
                this.$store.dispatch("users/getDebt", {cid: this.currentItem.customer_id, date: moment.parseZone(this.currentItem.created_at).format(configs.SQL_DATE_FORMAT)}).then((debt) => {
                    const frame_printing = print_export_receipt(this.currentItem, this.currentItem.receipt_products, debt);
                    var doc = document.getElementById('print_frame').contentWindow.document;
                    doc.open();
                    doc.write(frame_printing);
                    doc.close();
                    setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
                });
            },
            exportData() {
                this.$store.dispatch("receipts/export_excel", {id: this.currentItem.id});
            },
            filter_proname(item) {
                return item.product_code + ' - ' + item.name;
            },
            onSelectSuggestion() {
                const selectedPro = _.find(this.search_items, {'id': this.otherProductId});
                if(selectedPro) {
                    this.otherProductCode = selectedPro.product_code;
                    this.otherProductName = selectedPro.name;
                    this.otherProductPrice = this.selectedCustomer && this.selectedCustomer.retailer && selectedPro.retail_price ? selectedPro.retail_price : selectedPro.price;
                    this.otherProductQty = 1;
                }
            }
        },
        mounted() {
            this.refreshData();
            this.$store.dispatch("users/getList", {filter: [{column: 'role', value: configs.ROLE_TYPE.Customer, condition: "equal"}]});
            this.$root.$emit('REQUEST_ROOT_OPTION', {});
            this.$root.$on("REQUEST_CREATE_DATA", this.exportData);
            this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
            this.$root.$on("REQUEST_OTHER_ACTION", this.printData);
            this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_CREATE_DATA", this.exportData);
            this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
            this.$root.$off("REQUEST_OTHER_ACTION", this.printData);
            this.$root.$off("REQUEST_REFRESH_DATA", this.refreshData);
        },
    };
    </script>